import { Channel } from '@domain/channel';
import { useGenericQuery } from '@hooks/use-generic-query';
import { paramsSerializer } from '@utils/format-params';
import { Params } from '@utils/format-params/format-params.type';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';

const getEventChannelsByIdFetch = async (companyId: string, clubId?: string, orderBy?: string, sort?: string) => {
  const queryParams = paramsSerializer({ orderBy, clubId, sort } as Params);
  const url = `${import.meta.env.VITE_EVENTS_HOST}/v1/nightgraph/companies/${companyId}/channels?${queryParams}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetCompanyChannels = ({
  companyId,
  clubId,
  orderBy,
  sort,
  options,
}: {
  companyId: string;
  clubId?: string;
  orderBy?: string;
  sort?: string;
  options?: Record<string, boolean>;
}) => {
  return useGenericQuery<Channel[], RequestError>(
    [QUERY_KEYS.getCompanyChannels, companyId, clubId, orderBy, sort],
    () => getEventChannelsByIdFetch(companyId, clubId, orderBy, sort),
    options
  );
};
